module.exports = __webpack_public_path__ + "img/wall-ai.b8db9437.png";